module.exports = __webpack_public_path__ + "static/media/girl-with-phone.2f17ced4.png";